import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { ListLayout } from '../../global/tables/table-list-layout';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { AccountUsersVM } from '../account-users.viewmodel';
import { Paging } from '../../global/_paging/paging-container';
import { AccountUsersListItem } from './_acount-users-list-item/acount-users-list-item';
import { IAccountUsersDTO } from '../../../api/account-users.dao';
import DefaultButton from '../../global/default-button/default-button';
import { DOWNLOAD_ACCOUNT_USERS_TEXT } from '../../../constants/account-users.constants';

interface IProps {
    intl: IntlShape;
    vm: AccountUsersVM;
}

const AccountUsersList = injectIntl(
    mobxReact.observer((props: IProps) => {
        const { vm, intl } = props;
        const { accountUsersList, isLoading } = vm;

        const title = intl.formatMessage({
            id: 'oe.accountUsers.pageTitle',
            defaultMessage: 'Account Users',
            description: 'Section header'
        });

        const thead = [
            intl.formatMessage({
                id: 'oe.common.firstName',
                description: 'Label text',
                defaultMessage: 'First Name'
            }),
            intl.formatMessage({
                id: 'oe.common.lastName',
                description: 'Label text',
                defaultMessage: 'Last name'
            }),
            intl.formatMessage({
                id: 'oe.common.email',
                description: 'Label text',
                defaultMessage: 'Email'
            }),
            intl.formatMessage({
                id: 'oe.common.roles',
                description: 'Label text',
                defaultMessage: 'Roles'
            }),
            intl.formatMessage({
                id: 'oe.common.status',
                description: 'Label text',
                defaultMessage: 'Status'
            }),
            intl.formatMessage({
                id: 'oe.common.createdDate',
                description: 'Label text',
                defaultMessage: 'Created Date & Time'
            }),
            intl.formatMessage({
                id: 'oe.common.lastLoginDate',
                description: 'Label text',
                defaultMessage: 'Last Login Date & Time'
            })
        ];

        const isEmpty = !accountUsersList?.length;

        return (
            <div className='page-container'>
                <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                    <h1 className='text-ellipsis'>{title}</h1>
                    <div className='horizontal-row__align-to-row-end'>
                        <div className='buttons-block'>
                            <DefaultButton
                                className='account-users-list__button-new'
                                modifier='fat'
                                text={intl.formatMessage(DOWNLOAD_ACCOUNT_USERS_TEXT)}
                                onClick={vm.downloadAccountUsersCSV}
                            />
                        </div>
                    </div>
                </section>
                <section className='accounts-list fixed-list-layout'>
                    <div>
                        <ListLayout thead={thead}>
                            {!isLoading && !isEmpty && accountUsersList.map((item: IAccountUsersDTO) => {
                                    return (
                                        <AccountUsersListItem
                                            key={item.username}
                                            intl={intl}
                                            {...item}
                                        />
                                    );
                                })}
                            {isLoading && <TableLoadingRow colSpan={thead.length} />}
                        </ListLayout>
                        {!isLoading && isEmpty && (
                            <div className='empty-list-message'>
                                <FormattedMessage
                                    description='Account users list empty text'
                                    defaultMessage='There are no account users.'
                                    id='oe.accountUsers.emptyListText'
                                />
                            </div>
                        )}
                    </div>
                </section>
                {!isLoading && <Paging pagingVM={vm.paginationVM} />}
            </div>
        );
    })
);

export default AccountUsersList;